import React, { useEffect, useState } from "react";
import Axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../../App.css";

const Register = () => {
  const navigate = useNavigate();

  const [userR, setUserR] = useState({
    name: "",
    email: "",
    password: "",
    confirm_password: "",
  });

  const [profilePic, setProfilePic] = useState("");
  const [profileUrl, setProfileUrl] = useState(undefined);

  let name, value;
  const userInputFn = (event) => {
    name = event.target.name;
    value = event.target.value;

    setUserR({ ...userR, [name]: value });
  };

  const registerFieldsFn = async () => {
    try {
      const { name, email, password, confirm_password } = userR;

      const res = await Axios.post(
        "https://blogappserver-8sw1.onrender.com/register",
        {
          name,
          email,
          password,
          confirm_password,
          profilepic: profileUrl,
        }
      );

      if (res.status === 400 || !res.data) {
        toast("Invalid Credentials..!!", { type: "error" });
      } else {
        toast("Register Successfully..!!", { type: "success" });
        navigate("/login", { replace: true });
      }
    } catch (error) {
      toast("Invalid Credentials..!!", { type: "error" });
    }
  };

  const uploadProfilePicFn = async () => {
    try {
      const data = new FormData();
      data.append("file", profilePic);
      data.append("upload_preset", "blogify-web");
      data.append("cloud_name", "ninja-cloud");

      const res = await Axios.post(
        "https://api.cloudinary.com/v1_1/ninja-cloud/image/upload",
        data
      );
      if (res.status === 200) {
        const imageUrl = res.data.secure_url;
        setProfileUrl(imageUrl);
      }
    } catch (error) {}
  };

  const registerClickFn = (e) => {
    e.preventDefault();
    if (profilePic) {
      uploadProfilePicFn();
    } else {
      registerFieldsFn();
    }
  };

  useEffect(() => {
    if (profileUrl) {
      registerFieldsFn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileUrl]);

  return (
    <>
      {/* <div className="container">
        <h2 className="header">Create an account</h2>

        <form method="POST">
          <br />
          <div className="form-outline mb-2">
            <label className="form-label" htmlFor="name">
              Name
            </label>
            <input
              type="text"
              name="name"
              id="name"
              value={userR.name}
              onChange={userInputFn}
              className="form-control form-control-sm"
            />
          </div>

          <div className="form-outline mb-2">
            <label className="form-label" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              name="email"
              id="email"
              value={userR.email}
              onChange={userInputFn}
              className="form-control form-control-sm"
            />
          </div>

          <div className="form-outline mb-2">
            <label className="form-label" htmlFor="password">
              Password
            </label>
            <input
              type="password"
              name="password"
              id="password"
              value={userR.password}
              onChange={userInputFn}
              className="form-control form-control-sm"
            />
          </div>

          <div className="form-outline mb-2">
            <label className="form-label" htmlFor="confirmpassword">
              Confirm Password
            </label>
            <input
              type="password"
              name="confirm_password"
              id="confirmpassword"
              value={userR.confirm_password}
              onChange={userInputFn}
              className="form-control form-control-sm"
            />
          </div>

          <div className="form-outline mb-2">
            <label className="form-label" htmlFor="confirmpassword">
              Profile Pic
            </label>
            <input
              type="file"
              name="profilepic"
              id="profilepic"
              onChange={(e) => setProfilePic(e.target.files[0])}
              className="form-control form-control-sm"
            />
          </div>

          <div className="d-flex justify-content-center">
            <button
              type="submit"
              onClick={registerClickFn}
              className="btn btn-primary btn-lg button"
            >Register</button>
          </div>
          <p className="text-center text-muted mt-3 pb-4">
            Have already an account?
            <NavLink to="/login" className="fw-bold text-body">
              <u> Login here</u>
            </NavLink>
          </p>
        </form>
      </div> */}
 
      <div className="bg-white" style={{margin: "3% 14%"}}>
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card border border-1">
              <div className="card-body">
                <h2 className="card-title text-center">Create an Account</h2>

                <form method="POST">
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      value={userR.name}
                      onChange={userInputFn}
                      className="form-control"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      value={userR.email}
                      onChange={userInputFn}
                      className="form-control"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      name="password"
                      id="password"
                      value={userR.password}
                      onChange={userInputFn}
                      className="form-control"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="confirm_password" className="form-label">
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      name="confirm_password"
                      id="confirm_password"
                      value={userR.confirm_password}
                      onChange={userInputFn}
                      className="form-control"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="profilepic" className="form-label">
                      Profile Pic
                    </label>
                    <input
                      type="file"
                      name="profilepic"
                      id="profilepic"
                      onChange={(e) => setProfilePic(e.target.files[0])}
                      className="form-control"
                    />
                  </div>

                  <div className="text-center">
                    <button
                      type="submit"
                      onClick={registerClickFn}
                      className="btn btn-primary btn-lg"
                    >
                      Register
                    </button>
                  </div>

                  <p className="text-center text-muted mt-3">
                    Already have an account?{" "}
                    <NavLink to="/login" className="fw-bold text-body">
                      <u>Login here</u>
                    </NavLink>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Register;
